import type {NodeAttributes} from "../../stem-core/ui/NodeAttributes";
import {type UIChild, UI, type PartialOptions} from "../../stem-core/ui/UIBase";
import {Theme} from "../../stem-core/ui/style/Theme";
import {capitalize, toArray} from "../Utils";

export const DividerPositions = {
    TOP: "top",
    BOTTOM: "bottom"
};

interface ListItemOptions {
    dividerOptions?: Record<string, any>;
}

class ListItem extends UI.Element<ListItemOptions> {
    getDefaultOptions(): PartialOptions<ListItem> {
        return {
            ...super.getDefaultOptions(),
            /*
                Each element of the list can be visually separated from other list items.
                The divider renders as a ListItem border and could be configured using dividerOptions object.
                This object has the following format:
                {
                    position: <DividerPositions value / Array of DividerPositions> | Default value: " ,
                    width: <String> | Default value: "1px",
                    color: <String> | Default value: DIVIDER_LINE_COLOR from theme properties
                }
             */
            dividerOptions: {}
        }
    }

    extraNodeAttributes(attr: NodeAttributes) {
        super.extraNodeAttributes(attr);
        const dividerSettings = {
            position: DividerPositions.BOTTOM,
            width: "1px",
            color: Theme.props.DIVIDER_LINE_COLOR,
            ...this.options.dividerOptions,
        };

        // add border (divider) styles
        attr.setStyle("border", "0px solid " + dividerSettings.color);

        for (let position of toArray(dividerSettings.position)) {
            attr.setStyle(`border${capitalize(position)}Width`, dividerSettings.width);
        }
    }
}

// TODO shit class: if you're adding a divider, don't add it before the first or after the last element. Use a fucking "if"
interface ListOptions {
    dividerOptions?: Record<string, any>;
}

export class List extends UI.Element<ListOptions> {
    getDefaultOptions(): PartialOptions<List> {
        return {
            ...super.getDefaultOptions(),
            /*
                Each element of the list can be visually separated from other list items.
                The divider renders as a ListItem border and could be configured using dividerOptions object.
                This object has the following format:
                {
                    position: <DividerPositions value> | <Array of DividerPositions>,
                    width: <String> | Default value: "1px",
                    color: <String> | Default value: DIVIDER_LINE_COLOR from theme properties
                }
             */
            dividerOptions: {},
            testId: "list",
        };
    }

    render() {
        return (this.getGivenChildren() as UIChild[]).map(child => <ListItem testId="listItem" dividerOptions={this.options.dividerOptions}>{child}</ListItem>)
    }
}
